import { useEffect, useState } from 'react';
import { api, ROLE_NAMES } from '../api';
import { Modal, Field, Input, useToast, Loading, ErrorBox } from '../ui';
import { Icons } from '../icons';

export default function Users() {
  const [list, setList] = useState<any[] | null>(null);
  const [edit, setEdit] = useState<any>(null);
  const [err, setErr] = useState('');
  const toast = useToast();

  const load = () => { setErr(''); api.get('/users').then(setList).catch((e) => { setErr(e.message); setList([]); }); };
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      if (edit.id) {
        // faqat kerakli maydonlar; bo'sh parol yuborilmaydi (aks holda 400)
        const body: any = { fullName: edit.fullName, role: edit.role, isActive: edit.isActive };
        if (edit.password) body.password = edit.password;
        await api.patch('/users/' + edit.id, body);
      } else {
        await api.post('/users', { login: edit.login, password: edit.password, fullName: edit.fullName, role: edit.role });
      }
      toast('Saqlandi'); setEdit(null); load();
    } catch (e: any) { toast(e.message, true); }
  };
  const remove = async (id: number) => {
    if (!confirm("Foydalanuvchini o'chirasizmi?")) return;
    try { await api.del('/users/' + id); toast("O'chirildi"); load(); } catch (e: any) { toast(e.message, true); }
  };

  if (err) return <ErrorBox text={err} onRetry={load} />;
  if (!list) return <Loading />;
  return (
    <div>
      <div className="page-head">
        <div><h1 className="page-title">Foydalanuvchilar</h1><p className="page-sub">{list.length} ta foydalanuvchi</p></div>
        <button className="btn btn-primary" onClick={() => setEdit({ role: 'zakaz_operator' })}>+ Yangi foydalanuvchi</button>
      </div>
      <div className="table-wrap">
        <table>
          <thead><tr><th>Login</th><th>F.I.O</th><th>Rol</th><th>Holat</th><th></th></tr></thead>
          <tbody>
            {list.map((u) => (
              <tr key={u.id}>
                <td>{u.login}</td><td>{u.fullName}</td><td>{ROLE_NAMES[u.role] || u.role}</td>
                <td><span className={'badge ' + (u.isActive ? 'b-received' : 'b-cancelled')}>{u.isActive ? 'Faol' : 'Bloklangan'}</span></td>
                <td><div className="act-row">
                  <button className="act act-edit" title="Tahrirlash" onClick={() => setEdit({ ...u, password: '' })}><Icons.edit size={16} /></button>
                  {u.login !== 'admin' && <button className="act act-del" title="O'chirish" onClick={() => remove(u.id)}><Icons.trash size={16} /></button>}
                </div></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {edit && (
        <Modal title={edit.id ? 'Tahrirlash' : 'Yangi foydalanuvchi'} onClose={() => setEdit(null)}>
          <div className="grid-2">
            {!edit.id && <Field label="Login *"><Input value={edit.login || ''} onChange={(e) => setEdit({ ...edit, login: e.target.value })} /></Field>}
            <Field label="F.I.O *"><Input value={edit.fullName || ''} onChange={(e) => setEdit({ ...edit, fullName: e.target.value })} /></Field>
            <Field label="Rol">
              <select className="input" value={edit.role} onChange={(e) => setEdit({ ...edit, role: e.target.value })}>
                {Object.entries(ROLE_NAMES).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
              </select>
            </Field>
            <Field label={edit.id ? 'Yangi parol (bo\'sh = o\'zgarmaydi)' : 'Parol *'}><Input type="password" value={edit.password || ''} onChange={(e) => setEdit({ ...edit, password: e.target.value })} /></Field>
            {edit.id && <Field label="Holat">
              <select className="input" value={edit.isActive ? '1' : '0'} onChange={(e) => setEdit({ ...edit, isActive: e.target.value === '1' })}>
                <option value="1">Faol</option><option value="0">Bloklangan</option>
              </select>
            </Field>}
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            <button className="btn" onClick={() => setEdit(null)}>Bekor</button>
            <button className="btn btn-primary" onClick={save}>Saqlash</button>
          </div>
        </Modal>
      )}
    </div>
  );
}
